(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"Main_banner_atlas_1", frames: [[0,922,909,907],[0,0,903,920],[911,910,891,907],[905,0,906,908]]},
		{name:"Main_banner_atlas_2", frames: [[902,0,897,894],[0,0,900,892]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.Background = function() {
	this.initialize(img.Background);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,4320,1320);


(lib.Bibimbap00000BBGBeefBibimbap18OZ10CTGrocery_dish = function() {
	this.initialize(ss["Main_banner_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.Japchae54053BBGChickenJapchae18OZ10CTGrocerydish = function() {
	this.initialize(ss["Main_banner_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.Layer5 = function() {
	this.initialize(ss["Main_banner_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.Layer6 = function() {
	this.initialize(ss["Main_banner_atlas_2"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.Layer7 = function() {
	this.initialize(ss["Main_banner_atlas_2"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.SpicySaucedDumplings54063BBGSpicySaucedDumplings18OZ10CTGrocerydish = function() {
	this.initialize(ss["Main_banner_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.SpicySaucedDumplings54063BBGSpicySaucedDumplings18OZ10CTGrocerydish_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.SpicySaucedDumplings54063BBGSpicySaucedDumplings18OZ10CTGrocerydish();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SpicySaucedDumplings54063BBGSpicySaucedDumplings18OZ10CTGrocerydish_1, new cjs.Rectangle(0,0,906,908), null);


(lib.Layer7_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Layer7();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Layer7_1, new cjs.Rectangle(0,0,900,892), null);


(lib.Layer6_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Layer6();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Layer6_1, new cjs.Rectangle(0,0,897,894), null);


(lib.Layer5_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Layer5();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Layer5_1, new cjs.Rectangle(0,0,891,907), null);


(lib.Japchae54053BBGChickenJapchae18OZ10CTGrocerydish_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Japchae54053BBGChickenJapchae18OZ10CTGrocerydish();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Japchae54053BBGChickenJapchae18OZ10CTGrocerydish_1, new cjs.Rectangle(0,0,903,920), null);


(lib.Bibimbap00000BBGBeefBibimbap18OZ10CTGrocery_dish_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Bibimbap00000BBGBeefBibimbap18OZ10CTGrocery_dish();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Bibimbap00000BBGBeefBibimbap18OZ10CTGrocery_dish_1, new cjs.Rectangle(0,0,909,907), null);


// stage content:
(lib.Mainbanner = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Japchae_54053_BBG_Chicken_Japchae_18OZ_10CT_Grocery_dish
	this.instance = new lib.Japchae54053BBGChickenJapchae18OZ10CTGrocerydish_1();
	this.instance.setTransform(571.45,869.6,0.4452,0.4452,0,0,0,451.6,460.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(14).to({regX:451.7,regY:460.2,y:807.6},0).to({regX:451.6,regY:460.1,rotation:360,y:466.6},35).wait(251));

	// Bibimbap_00000_BBG_Beef_Bibimbap_18OZ_10CT_Grocery_dish
	this.instance_1 = new lib.Bibimbap00000BBGBeefBibimbap18OZ10CTGrocery_dish_1();
	this.instance_1.setTransform(848.85,-263,0.4452,0.4452,0,0,0,454.6,453.4);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(49).to({y:-232},0).to({rotation:360,y:140},35).wait(216));

	// Layer_7
	this.instance_2 = new lib.Layer7_1();
	this.instance_2.setTransform(1085.05,888.35,0.4452,0.4452,0,0,0,450.1,446.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(84).to({y:826.35},0).to({rotation:360,y:485.35},35).wait(181));

	// Spicy_Sauced_Dumplings_54063_BBG_Spicy_Sauced_Dumplings_18OZ_10CT_Grocery_dish
	this.instance_3 = new lib.SpicySaucedDumplings54063BBGSpicySaucedDumplings18OZ10CTGrocerydish_1();
	this.instance_3.setTransform(1321.5,-294.15,0.4452,0.4452,0,0,0,453.2,453.9);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(119).to({y:-232.15},0).to({rotation:360,y:139.85},35).wait(146));

	// Layer_5
	this.instance_4 = new lib.Layer5_1();
	this.instance_4.setTransform(1566.55,860.65,0.4452,0.4452,0,0,0,445.6,453.6);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(154).to({y:829.65},0).to({rotation:360,y:488.65},35).wait(111));

	// Layer_6
	this.instance_5 = new lib.Layer6_1();
	this.instance_5.setTransform(1791.45,-241.05,0.4452,0.4452,0,0,0,448.6,446.9);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(189).to({y:-210.05},0).to({rotation:360,y:130.95},35).wait(76));

	// Background
	this.instance_6 = new lib.Background();
	this.instance_6.setTransform(0,-2,0.4452,0.4452);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(300));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(960,-202.7,1113.1999999999998,1289.6000000000001);
// library properties:
lib.properties = {
	id: '6BBB1C3C77501B4FA1B84A66DB6ECBED',
	width: 1920,
	height: 587,
	fps: 30,
	color: "rgba(0,0,0,0)",
	opacity: 1.00,
	manifest: [
		{src:"images/Background.jpg", id:"Background"},
		{src:"images/Main_banner_atlas_1.png", id:"Main_banner_atlas_1"},
		{src:"images/Main_banner_atlas_2.png", id:"Main_banner_atlas_2"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['6BBB1C3C77501B4FA1B84A66DB6ECBED'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
var createjs, AdobeAn;